import React from "react";
import {
    Table,
    TableRow,
    TableHead,
    TableBody,
    TableCell,
    IconButton
} from "@mui/material";

import {
    ArrowForward as ShowLogicChannelsIcon,
    RemoveCircle as RemoveIcon
} from "@mui/icons-material";

import styles from "./hoverableStyles.module.css"

import { useTranslation } from "react-i18next"

export default function SettingsLogicsTable({ data, handleEditLogicName, handleRemoveLogic, handleShowLogicChannels }) {
    const { t } = useTranslation();

    var keys = ["#", t("Name"), ""];

    return (
        <Table size="small">
            <TableHead>
                <TableRow>
                    {keys.map(key => (
                        <TableCell key={key} style={{ fontWeight: 'bold' }}>{key}</TableCell>
                    ))}
                </TableRow>
            </TableHead>
            <TableBody>
                {data.map(logic => (
                    <TableRow key={logic.Id}>
                        <TableCell className={styles.cell}>{logic.Id}</TableCell>
                        <TableCell
                            className={styles.hoverableCell}
                            onClick={() => handleEditLogicName(logic)}
                        >
                            {logic.Name}
                        </TableCell>
                        <TableCell className={styles.cell} style={{ display: "flex", flexDirection: "row" }}>
                            <IconButton
                                color="secondary"
                                onClick={() => handleRemoveLogic(logic)}
                            >
                                <RemoveIcon />
                            </IconButton>
                            <IconButton
                                color="primary"
                                onClick={() => handleShowLogicChannels(logic)} >
                                <ShowLogicChannelsIcon />
                            </IconButton>
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
}
